// extracted by mini-css-extract-plugin
export default {"hotelCountry":"hotelImage-module__hotelCountry__OP-DJ","hotelRating":"hotelImage-module__hotelRating__91zp-"};